/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_PesticidesInputs */

const vi_care_log_pesticides = /** @type {(inputs: Care_Log_PesticidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thuốc BVTV sử dụng`)
};

/**

* @param {Care_Log_PesticidesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_pesticides = /** @type {((inputs?: Care_Log_PesticidesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_PesticidesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_pesticides(inputs)
});